import { render, staticRenderFns } from "./AddNewCategoryForm.vue?vue&type=template&id=06e22a9e&scoped=true&"
import script from "./AddNewCategoryForm.vue?vue&type=script&lang=js&"
export * from "./AddNewCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e22a9e",
  null
  
)

export default component.exports